import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import {
  colorBlackAlpha60,
  colorWhite,
  colorWhiteAlpha95,
  elevatedSurfaceBoxShadow,
  transition,
} from '../../../shared/style-settings'

export const useItemImagesStyles = makeStyles((theme: Theme) => {
  const size = 120

  return createStyles({
    root: {
      marginBottom: theme.spacing(5),
    },
    uploadArea: {
      display: 'inline-flex',
      flexDirection: 'column',
      width: '100%',
      height: size,
      position: 'relative',
      borderRadius: theme.shape.borderRadius * 2,
      overflow: 'hidden',
      boxShadow: elevatedSurfaceBoxShadow,
      transition: transition,
      cursor: 'pointer',
    },
    progressOverlay: {
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backdropFilter: 'blur(4px)',
      backgroundColor: colorWhiteAlpha95,
      zIndex: 10,
      borderRadius: theme.shape.borderRadius * 2,
      overflow: 'hidden',
      '& .MuiCircularProgress-root': {
        backgroundColor: 'transparent',
        padding: 0,
        boxShadow: 'none',
      },
    },
    dragArea: {
      flexGrow: 1,
      border: `2px dashed ${theme.palette.divider}`,
      borderBottom: 'none',
      borderRadius: `${theme.shape.borderRadius * 2}px ${
        theme.shape.borderRadius * 2
      }px 0 0`,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: theme.palette.common.white,
      transition: transition,
      '& *': {
        pointerEvents: 'none',
      },
      '&.highlight': {
        borderColor: theme.palette.primary.main,
      },
      '& .MuiSvgIcon-root': {
        fontSize: '2.25rem',
        color: theme.palette.grey[400],
        marginBottom: theme.spacing(1),
      },
    },
    dragTitle: {
      color: theme.palette.grey[700],
      marginTop: theme.spacing(1),
      fontSize: '0.65rem',
      fontWeight: 600,
      lineHeight: 1.35,
    },
    uploadButton: {
      height: 28,
      backgroundColor: theme.palette.primary.main,
      color: colorWhite,
      fontSize: '0.65rem',
      fontWeight: 600,
      textTransform: 'none',
      borderRadius: 0,
      transition: transition,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    itemImage: {
      width: '100%',
      height: size,
      position: 'relative',
      backgroundColor: theme.palette.grey[100],
      margin: 'auto',
      borderRadius: theme.shape.borderRadius * 2,
      overflow: 'hidden',
      boxShadow: elevatedSurfaceBoxShadow,
      transition: transition,
    },
    itemImageDeleteButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      border: 'none',
      background: colorBlackAlpha60,
      color: colorWhite,
      padding: theme.spacing(0.75, 1.25),
      cursor: 'pointer',
      opacity: 0.9,
      transition: transition,
      borderRadius: theme.shape.borderRadius,
      fontSize: '0.75rem',
      fontWeight: 500,
      zIndex: 5,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:hover': {
        background: theme.palette.error.main,
        opacity: 1,
      },
      '& .MuiSvgIcon-root': {
        fontSize: '1.25rem',
      },
    },
    imgBody: {
      position: 'relative',
    },
    move: {
      cursor: 'move',
      position: 'relative',
    },
    imageHolder: {
      width: '100%',
      height: '100%',
      '& > div': {
        width: '100%',
        height: '100%',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: theme.palette.common.white,
      },
    },
    itemImageNotes: {
      textAlign: 'start',
    },
    draggingElement: {
      cursor: 'move',
      display: 'block',
      boxSizing: 'border-box',
      position: 'relative',
      overflow: 'visible',
      zIndex: 100,
      opacity: 0.9,
      '&:before': {
        display: 'block',
        top: -4,
        left: -4,
        right: -4,
        bottom: -4,
        content: '""',
        position: 'absolute',
        zIndex: 0,
        border: `3px ${theme.palette.primary.main} dashed`,
        borderRadius: theme.shape.borderRadius * 2,
      },
    },
    defaultLabel: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      color: colorWhite,
      height: 24,
      backgroundColor: theme.palette.primary.main,
      lineHeight: '24px',
      fontSize: '0.6rem',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      textAlign: 'center',
      borderBottomLeftRadius: theme.shape.borderRadius * 2,
      borderBottomRightRadius: theme.shape.borderRadius * 2,
    },
  })
})
